<template>
    <div>
        <div class="v-flex">
            <div class="step-name">
                {{ row.type }}
            </div>
            <v-spacer />
            <v-hover v-slot="{ hover }" open-delay="200">
                <div>
                    <div class="v-flex">
                        <div
                            v-for="(step, index) in row.steps"
                            :key="index"
                            class="table-status"
                        >
                            <i :class="step.status.font + ' fa-' + step.status.symbol"></i>
                        </div>
                    </div>
                    <div v-if="hover" class="pa-0 elevation-4" style="position: absolute; width: 500px; background-color: white; z-index: 10">
                        <div
                               v-for="(step, index) in row.steps"
                               :key = index
                               class="v-flex"
                        >
                            <div class="info-cell step-name" >
                                {{ step.name }}
                            </div>
                            <div class="info-cell " style="width: 20px; ">
                                <i :class="step.status.font + ' fa-' + step.status.symbol"></i>
                            </div>
                            <div class="info-cell " style="width: calc(100% - 200px)">
                                {{step.status.name }}
                            </div>
                        </div>
                    </div>
                </div>
            </v-hover>
        </div>
        <div class="v-flex">
            <a @click.stop = "onClipboard" v-if="enableClipboard">
                <div class="clipboard-button" :class="row.clipboardEntry ? 'clipboard-button-active' : 'clipboard-button-inactive'">
                    Clipboard
                </div>
            </a>
            <v-spacer />
            <div class="customer">
                {{ row.unit.customer.name }}
            </div>
        </div>
    </div>
</template>

<script>

import Inc from "@/modules/inc/service/Inc";

export default {
    name: "CIncOverviewTypeStepEntryCell",

    props: {
        row: {

        },
    },

    computed: {
        terminated () {
            return this.row.status === "TERMINATED";
        },

        enableClipboard () {
            return !this.terminated && !this.row.deleted;
        }
    },

    methods: {
        onClipboard () {
            if (this.row.clipboardEntry) {
                Inc.clipboard.remove(this.row.clipboardEntry, this.row.unit).then(() => {
                    this.row.clipboardEntry = null;
                        this.$emit("clipboard", this.row)
                });
            } else {
                Inc.clipboard.add(this.row.incidentId, this.row.unit).then((incident) => {
                    const step = incident.data[0];
                    const entry = step.collection.find(e => e.unit.id === this.row.unit.id);
                    if (entry) {
                        this.row.clipboardEntry = entry.clipboardEntry;
                        this.$emit("clipboard", this.row)
                    }
                });
            }
        }
    }
}
</script>

<style scoped>

.clipboard-button-active {
    background-color: red;
    color: white;
}

.clipboard-button-inactive {
    background-color: white;
    border-style: solid;
    border-width: 1px;
    color: lightgray;
    border-color: lightgray;
}

.clipboard-button-active, .clipboard-button-inactive {
    border-radius: 10px;
    height: 18px;
    width: 80px;
    text-align: center;
    margin-top: 0;
    line-height: 18px;
}

.customer {
    font-size: 12px;
    margin-top: 6px;
    margin-bottom: 0;
    padding-bottom: 0;
    line-height: 10px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    padding-left: 4px;
}

.info-cell {
    padding: 8px;
    align-items: center;
    border-bottom: 1px solid #dee2e6;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.info-cell:not(:nth-child(3n)) {
    border-right: 1px solid #dee2e6;
}

.step-name {
    width: 180px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

</style>